import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";

import React, { useEffect } from "react";
import ContainedButton from "../Buttons/ContainedButton";

import ModalTitle from "../TextComponents/ModalTitle";
import EvrbedModal from "./EvrbedModal";
import ExitButton from "./ExitButton";

import SummaryTable from "./SummaryTable";

import { SHOPIFY_URL, shopifyProductVariants, constructRedirectUrl } from "../../utils/shopify.utils";
import {
  cartSelector,
  createCart,
  isSingleSleeperSelector,
  mattressConfigurationSelector,
  primarySleeperFirstNameSelector,
  secondarySleeperFirstNameSelector,
  updateMattressConfiguration,
  mattressConfigurationSlice
} from "../../redux/slices/mattressConfiguration";
import {
  currentStepDoubleSleeperMattressBuilderSelector,
  currentStepSingleSleeperMattressBuilderSelector,
  setIsIncorporateModalOpen,
  setIsSummaryModalOpen,
} from "../../redux/slices/customNavigation";
import {
  customerEmailAddressSelector,
  metaFieldIdSelector,
  shopifyCustomerSelector,
} from "../../redux/slices/customer";
import { getAdaptiveFontSize } from "../../utils/styling.utils";
import {
  getFirstName,
  getInfoModalText,
  saveMattressConfigurationToLocalStorage,
} from "../../utils/bedBuilder.utils";

import styled from "styled-components";
import useMediaQuery from "@mui/material/useMediaQuery";
import {getFinalEvrScore} from "../../utils/shopify.utils";
import ReactGA from "react-ga";

const StyledModalContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 5vh;
`;

const StyledSubTitle = styled.div`
  font-family: noto-sans;
  font-weight: bold;
`;

const SummaryModal = ({ open }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  //Media Queries
  const isSmartphoneScreen = useMediaQuery("(min-width: 0px)");
  const isSmallScreen = useMediaQuery("(min-width: 500px)");
  const isMediumScreen = useMediaQuery("(min-width: 768px)");
  const isLargeScreen = useMediaQuery("(min-width: 992px)");
  const isExtraLargeScreen = useMediaQuery("(min-width: 1200px)");
  const screenWidthHooks = {
    isSmartphoneScreen,
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isExtraLargeScreen,
  };
  const currentStepSingleSleeperMattressBuilder = useSelector(
    currentStepSingleSleeperMattressBuilderSelector
  );
  const currentStepDoubleSleeperMattressBuilder = useSelector(
    currentStepDoubleSleeperMattressBuilderSelector
  );
  const isSingleSleeper = useSelector(isSingleSleeperSelector);

  const primarySleeperFirstName = useSelector(primarySleeperFirstNameSelector);
  const secondarySleeperFirstName = useSelector(
    secondarySleeperFirstNameSelector
  );
  const bedSize = useSelector(
    state => state.mattressConfiguration.mattressConfiguration.bedSize
  );
  // console.log("=>(SummaryModal.js:86) bedSize", bedSize);
  const shopifyCustomer = useSelector(shopifyCustomerSelector);
  const metaFieldId = useSelector(metaFieldIdSelector);
  const mattressConfiguration = useSelector(mattressConfigurationSelector);
  const emailAddress = useSelector(customerEmailAddressSelector);
  // console.log("=>(SummaryModal.js:90) emailAddress", emailAddress);

  const cart = useSelector(cartSelector);
  const cartId = cart?.id?.split("gid://shopify/Cart/")?.[1];
  // console.log("=>(SummaryModal.js:92) cartId", cartId);

  const getRedirectUrl = () => {
    // let redirectUrl = SHOPIFY_URL + "cart/";
    // redirectUrl = redirectUrl + `${shopifyProductVariants[bedSize]}:1`;
    // redirectUrl = redirectUrl + `?checkout[email]=${emailAddress}`;

    let redirectUrl = constructRedirectUrl({
      mattressConfiguration: mattressConfiguration,
      mattressBuilder: mattressConfigurationSlice});
    return redirectUrl;
  };

  useEffect(() => {
    if (cart?.id !== "") {
      const redirectUrl = getRedirectUrl();
      console.log("redirecting to: " + redirectUrl);
      window.top.location.href = redirectUrl;
      setTimeout(() => {
        window.top.location.href = SHOPIFY_URL + "/cart";
      }, 500);
    }
  }, [cartId]);

  const handleUpdateMattressConfiguration = () => {
    const newMattressConfiguration = {
      metaFieldId: metaFieldId,
      id: shopifyCustomer.id,
      mattressConfiguration: mattressConfiguration,
    };
    dispatch(updateMattressConfiguration(newMattressConfiguration));
  };

  const getCartData = () => {
    return {
      email: emailAddress,
      merchandiseId: "gid://shopify/ProductVariant/40363786207371",
      bedSize: bedSize,
      attributes: [
        {
          key: "Mattress Configuration",
          value: JSON.stringify(mattressConfiguration),
        },
      ],
    };
  };

  const title = isSingleSleeper
    ? getFirstName()
    : `${primarySleeperFirstName} & ${secondarySleeperFirstName}`;

  return (
    <EvrbedModal
      title={"Evrbed Summary"}
      open={open}
      toggleModal={isOpen => dispatch(setIsSummaryModalOpen(isOpen))}
      styles={
        isMediumScreen
          ? {
              width: "40vw",
              height: "70vh",
              background: "white",
              minWidth: "700px",
              minHeight: "600px",
            }
          : { width: "100%", height: "100%", background: "white" }
      }
    >
      <StyledModalContainer
        className="text-center row"
        styles={isMediumScreen ? {} : { width: "100vw", height: "100vh" }}
      >
        <ExitButton
          onClick={() => dispatch(setIsSummaryModalOpen(false))}
        ></ExitButton>
        <ModalTitle
          className=""
          styles={{ width: isMediumScreen ? "100%" : "75%" }}
        >
          {title}
          {"'s Summary"}
        </ModalTitle>
        <StyledSubTitle
          style={{
            color: theme.COLORS.BLUE.darkBlueGreen,
            fontSize: isMediumScreen
              ? getAdaptiveFontSize({
                  screenWidthHooks,
                  fontSize: 1.2,
                })
              : "0.8rem",
            paddingLeft: isMediumScreen ? "5vw" : "10px",
            paddingRight: isMediumScreen ? "5vw" : "10px",
            maxWidth: isMediumScreen ? "40vw" : "85vw",
            marginTop: isMediumScreen ? "" : "25px",
          }}
        >
          {t(
            "Sleep Experts are using the information you provided to personalize your evrbed."
          )}
        </StyledSubTitle>
        <SummaryTable></SummaryTable>

        {/*<ContainedButton*/}
        {/*  className="col-auto"*/}
        {/*  color={theme.COLORS.WHITE.backgroundWhite}*/}
        {/*  fontColor={theme.COLORS.BLUE.darkBlueGreen}*/}
        {/*  variant="outlined"*/}
        {/*  styles={{*/}
        {/*    background: "white",*/}
        {/*    borderColor: theme.COLORS.BLUE.darkBlueGreen,*/}
        {/*    ":hover": {*/}
        {/*      backgroundColor: theme.COLORS.BLUE.darkBlueGreen,*/}
        {/*      color: theme.COLORS.WHITE.backgroundWhite,*/}
        {/*    },*/}
        {/*  }}*/}
        {/*  onClick={() => {*/}
        {/*    //Update in local storage*/}
        {/*    // console.log("saving to local storage");*/}

        {/*    // saveMattressConfigurationToLocalStorage(mattressConfiguration);*/}
        {/*    // handleUpdateMattressConfiguration();*/}
        {/*    // dispatch(setIsSummaryModalOpen(false));*/}

        {/*    // console.log(constructRedirectUrl({mattressConfiguration: mattressConfiguration, mattressBuilder: mattressConfigurationSlice}));*/}
        {/*    // alert('saved');*/}
        {/*  }}*/}
        {/*>*/}
        {/*  {t("SAVE MY BED")}*/}
        {/*</ContainedButton>*/}
        <ContainedButton
          className="col-auto"
          id="buy-btn"
          onClick={() => {
            document.getElementById('buy-btn').classList.toggle('hidden');
            document.getElementById('loading-btn').classList.toggle('hidden');
            handleUpdateMattressConfiguration();
            let redirectUrl = constructRedirectUrl({
              mattressConfiguration: mattressConfiguration,
              mattressBuilder: mattressConfigurationSlice});
            window.top.location.href = redirectUrl;
            ReactGA.pageview('/mattress-builder/see-evrbed-pricing');
          }}
        >
          {t("SEE MY EVRBED PRICING")}
        </ContainedButton>
        <ContainedButton
          className="col-auto hidden"
          id="loading-btn"
        >
          {t("LOADING...")}
        </ContainedButton>
      </StyledModalContainer>
    </EvrbedModal>
  );
};

export default SummaryModal;
